import { useI18n } from "../../../i18n";
import { fmtDateTime } from "../../../lib/format";

export const CallLog = ({ calls }) => {
  const { t } = useI18n();
  return (
    <section className="rounded-2xl bg-white p-5 shadow-sm" data-testid="softone-call-log">
      <h2 className="mb-3 text-base font-semibold text-navy md:text-lg">{t("softone.recentCalls")}</h2>
      <div className="-mx-5 overflow-x-auto px-5">
        <table className="w-full min-w-[560px] text-xs">
          <thead className="text-left text-slate-500">
            <tr>
              <th className="py-2 pr-3 font-medium">{t("statement.date")}</th>
              <th className="py-2 pr-3 font-medium">{t("softone.kind")}</th>
              <th className="py-2 pr-3 font-medium">{t("softone.call")}</th>
              <th className="py-2 pr-3 text-right font-medium">ms</th>
              <th className="py-2 font-medium">{t("softone.result")}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 text-navy">
            {calls.map((c, i) => (
              <tr key={`${c.timestamp}-${i}`}>
                <td className="whitespace-nowrap py-2 pr-3">{fmtDateTime(c.timestamp)}</td>
                <td className="py-2 pr-3">{c.kind}</td>
                <td className="py-2 pr-3 font-medium">{c.name}</td>
                <td className="py-2 pr-3 text-right tabular-nums">{c.duration_ms}</td>
                <td className={`py-2 ${c.success ? "text-brand" : "text-rose-600"}`}>{c.success ? "OK" : c.error}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
